import React from "react";

import { css } from "@emotion/react";

import { AttributesTag } from "./AttributesTag";
import { CSS_MQ } from "../../../../styles/breakpoints";
import { FrontendLineItemAttribute } from "../../../../components/HeaderComponent/subcomponents/MenuMetaComponent/ShoppingCart/getLineItemAttributes";

export const AttributesTags: React.FC<{
  attributes: Array<FrontendLineItemAttribute>;
  size?: "small" | "regular" | "tiny";
  dontTrim?: boolean;
  direction: "row" | "column";
}> = props => (
  <ul
    className={`size-${props.size ?? "regular"} direction-${props.direction}`}
    css={css`
      --m: 8px;

      ${CSS_MQ.atLeastMd} {
        &.size-regular {
          --m: 12px;
        }

        &.size-regular {
          --m: 16px;
        }

        &.size-tiny {
          --m: 0;
          margin-bottom: 4px;
        }
      }

      display: flex;

      &.direction-row {
        flex-direction: row;
      }

      &.direction-column {
        flex-direction: column;
      }

      align-items: flex-start;

      gap: var(--m);

      &:not(.size-tiny) {
        margin-bottom: var(--m);
      }
    `}
  >
    {props.attributes.map(attr => (
      <AttributesTag
        key={attr.label}
        label={attr.label}
        size={props.size}
        dontTrim={props.dontTrim}
        type={attr.type}
        customValue={attr.customValue}
      />
    ))}
  </ul>
);
